import * as React from 'react'

function PinLocationIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.065 20h3.346a2.667 2.667 0 012.529 1.824l.89 2.667A2.667 2.667 0 0124.3 28H7.7a2.667 2.667 0 01-2.53-3.51l.89-2.666A2.665 2.665 0 018.59 20h3.346"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 24s-8-6.39-8-12.223C8 7.483 11.581 4 16 4c4.419 0 8 3.483 8 7.777C24 17.611 16 24 16 24z"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.885 10.115a2.665 2.665 0 01-.843 4.386 2.666 2.666 0 11.843-4.386"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { PinLocationIcon }
